import { render, staticRenderFns } from "./SCAPayments.vue?vue&type=template&id=91f2b6c6&"
import script from "./SCAPayments.vue?vue&type=script&lang=js&"
export * from "./SCAPayments.vue?vue&type=script&lang=js&"
import style0 from "./SCAPayments.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports